<template>
    <div>
        Summary Page
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    submit(){
        this.$emit('submit', )
    }
}
</script>
